import { useEffect, useState, useContext } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";


import useToken from "../../hooks/useToken";
import { DataContext, DataProvier } from "./data/DataContext";
import { InitPage, TotalPage } from './data/Data';
import http from '../../services/http';
import { endPoints } from '../../utils/constanst';
import { GetDataRates, propLoading, propMsg, BuildData, BuildDataOportunity } from './data/Help';

import { Pages, PagesTitle } from './components/pages';
import { LineProgressBar, ControlButton, ModalControl, ModalMsgControl } from './components/controls';

import './Incendio_Hogar.css';


const Incendio_Hogar = () => {
    const { loading } = useToken();

    useEffect(() => {
        setTimeout(() => {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }, 600);
    }, []);

    return (
        <DataProvier loading={loading} >
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/ih_cr/" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layout = ({ location }: IPropsParam) => {
    const [index, setIndex] = useState(InitPage);
    const [propModal, setPropModal] = useState(propLoading);
    const [propModalMsg, setPropModalMsg] = useState(propMsg);
    const { IH_CR, setIH_CR } = useContext(DataContext);

    const Decrement = () => (index !== 0) ? setIndex(index - 1) : 0;
    const Increment = () => (index <= TotalPage) ? setIndex(index + 1) : 0;

    const Submit = () => {
        let result = document.querySelector("form") as HTMLFormElement;
        if (index == 0 && result.reportValidity()) {
            sendOportunity();
            Increment();
        }
        else if (index == 2 && result.reportValidity()) {
            GetRates();
        } else if (index == 3 && result.reportValidity()) {
            CreatePolicy();
        }
        else if (result.reportValidity())
            Increment();
    }

    const GetRates = () => {
        const data = GetDataRates(IH_CR);
        setPropModal({ ...propLoading, active: true });
        http(endPoints.tarificar(IH_CR.idPlan)).post(data).then((result) => {
            setIH_CR({ ...IH_CR, lstRate: result });
            Increment();
        }).catch((error) => {
            console.log(error);
            setPropModalMsg({ ...propModalMsg, active: true, txtMsg: error, closeModal: () => { setPropModalMsg({ ...propModalMsg, active: false }) } })
        }).finally(() => {
            setPropModal({ ...propLoading, active: false });
        });
    }

    const CreatePolicy = () => {
        setPropModal({ ...propLoading, active: true });
        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');
        const temp: IBuildData_IHCR_Props = {
            src: src,
            data: IH_CR
        }

        const data = BuildData(temp);
        http(endPoints.createIncendioHogar).post(data)
            .then((result) => {
                setIH_CR({ ...IH_CR, saved: true, numberPolicy: result.id });               
                http(endPoints.notificationMailIH(result.id, IH_CR.mail)).get().catch(x => console.log(x));
            }).catch((error) => {
                console.log(error);
                setIH_CR({ ...IH_CR, saved: false, numberPolicy: 0 });
            }).finally(() => {
                setPropModal({ ...propLoading, active: false });
                Increment();
            })
    }

    const sendOportunity = () => {
        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');
        const temp: IBuildData_IHCR_Props = {
            src: src,
            data: IH_CR
        }

        const data = BuildDataOportunity(temp);
        http(endPoints.createOportunityIH)
            .post(data)
            .catch((error) => {

            })
    }

    const sendMailIH = (numberPolicy: number, mail: string) => http(endPoints.notificationMailIH(numberPolicy, mail)).get();


    return (
        <div className="container">
            <div className="layout-ihcr">
                <div className="mt-10">
                    <p className="lbl-encabezado1 mb-10">
                        ¡Calcula tu seguro ahora!
                    </p>
                    <p className="lbl-encabezado2 mt-0 mb-30">
                        Con tu póliza de Incendio Hogar disfruta cada momento sin preocupaciones
                    </p>
                </div>
                <LineProgressBar index={(index < TotalPage ? index + 1 : TotalPage)} totalPages={TotalPage} />
                <form>
                    <div className="step-ihcr">
                        <div className="step-container-ihcr">
                            <PagesTitle index={index} />
                            <Pages index={index} />
                        </div>
                    </div>
                    <ControlButton indexPage={index}>
                        {index !== 0 &&
                            <button
                                className={`control-button-btn-ihcr prev`}
                                type="button"
                                onClick={Decrement}
                            >
                                Regresar
                            </button>
                        }
                        {
                            <button
                                className="control-button-btn-ihcr next"
                                type="button"
                                onClick={Submit}
                            >
                                Siguiente
                            </button>
                        }
                    </ControlButton>
                </form>
                <ModalControl
                    active={propModal.active}
                    txtMsg={propModal.txtMsg}
                />
                <ModalMsgControl
                    active={propModalMsg.active}
                    txtMsg={propModalMsg.txtMsg}
                    closeModal={propModalMsg.closeModal}
                />
            </div>
        </div>
    )
}

export default Incendio_Hogar;